import trTR from 'antd/es/locale/tr_TR';

export default trTR;
